(function () {
  function closeTooltip(container) {
    const trigger = container.querySelector('.tooltip-trigger');
    const tooltip = container.querySelector('.tooltip-text');

    if (!trigger || !tooltip) return;

    trigger.setAttribute('aria-expanded', 'false');
    tooltip.hidden = true;
  }

  function closeOtherTooltips(currentContainer) {
    document.querySelectorAll('.tooltip-container').forEach((container) => {
      if (container !== currentContainer) closeTooltip(container);
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.tooltip-trigger');

    if (trigger) {
      const container = trigger.closest('.tooltip-container');
      const tooltip = container?.querySelector('.tooltip-text');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (!container || !tooltip) return;

      closeOtherTooltips(container);
      trigger.setAttribute('aria-expanded', String(!isExpanded));
      tooltip.hidden = isExpanded;
      return;
    }

    if (!event.target.closest('.tooltip-container')) {
      document.querySelectorAll('.tooltip-container').forEach(closeTooltip);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const container = event.target.closest('.tooltip-container');
    if (!container) return;

    closeTooltip(container);
    container.querySelector('.tooltip-trigger')?.focus();
  });
})();